<!-- Modal de registro UNICON -->
<div *ngIf="isOpen" 
  class="modal-overlay"
  (click)="closeModal()">
  
  <!-- Contenido del modal -->
  <div class="modal-content" (click)="$event.stopPropagation()">
    
    <!-- Botón de cerrar (X) -->
    <button type="button" 
      class="close-button" 
      (click)="closeModal()"
      aria-label="Cerrar">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 5L5 15M5 5L15 15" stroke="#20202A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <!-- Logo de CANTERA -->
    <div class="logo-container">
      <img src="assets/img/cantera-blue.svg" alt="CANTERA" class="logo" />
    </div>

    <!-- Texto del modal -->
    <div class="text-container">
      <h2 class="title">Registrate para continuar</h2>
      <p class="description">
        Debes registrarte para chatear con un asesor, cotizar productos UNICON y coordinar tu pedido para la obra.
      </p>
    </div>

    <!-- Botones -->
    <div class="buttons-container">
      <button type="button" 
        class="btn-primary" 
        (click)="goToRegister()">
        Registrarme gratis
      </button>
      
      <button type="button" 
        class="btn-secondary" 
        (click)="goToLogin()">
        Iniciar sesión
      </button>
    </div>

  </div>
</div>

